module.exports = __webpack_public_path__ + "assets/images/project/jordan-desktop.jpg?v=a42347c4";